import { computed } from "@nuxtjs/composition-api";
import { getGallery as getProductGallery } from "../../getters/productGetters";
import { useImage } from "@wemade-vsf/composables";
function useProductGallery(product, imgPlaceholder = "") {
  const { getMagentoImage, imageSizes } = useImage();
  const productGallery = computed(() => getProductGallery(product.value).map((img) => ({
    mobile: { url: getMagentoImage(img.small) },
    desktop: { url: getMagentoImage(img.normal) },
    big: { url: getMagentoImage(img.big) },
    alt: product.value.name,
    placeholder: imgPlaceholder,
    video: img.video && img.video.video_url ? img.video : null
  })));
  return {
    productGallery,
    imageSizes
  };
}
var useProductGallery_default = useProductGallery;
export * from "./useProductGallery";
export {
  useProductGallery_default as default,
  useProductGallery
};
